import React from 'react'
// import { Button } from './Button'
import './Footer.css';
import { Link } from 'react-router-dom';

function Footer() {
  return (
    <div className='footer-container'>
        {/* <section className='footer-subscription'>
            <p className='footer-subscription-heading'>
                Join the Adventure, Subscribe to our newsletter!
            </p>
            <p className='footer-subscription-text'>
                You can unsubscribe anytime!
            </p>
            <div className='input-areas'>
                <form>
                    <input type='email' name='email' placeholder='Your Email' className='footer-input'/>
                    <Button buttonStyle='btn--outline'> Subscribe</Button>
                </form>
            </div>
        </section> */}
        <div class='footer-links'>
        <div className='footer-link-wrapper'>
          <div class='footer-link-items'>
            <h2>Jays Woodwork</h2>
            <img src='/images/JMSLogo.png' alt='Logo' className='footer-image'/>
          </div>
        </div>
        <div className='footer-link-wrapper'>
          <div class='footer-link-items'>
            <h2>Who We Are</h2>
            <Link to='/about'>About Us</Link>
            <Link to='/about'>FAQ</Link>
            <Link to='https://www.instagram.com/'>Instagram <i class='fab fa-instagram'/></Link>
            <Link to='https://www.facebook.com/'>Facebook <i class='fab fa-facebook-f'/></Link>
            <Link to='https://www.youtube.com/'>Youtube <i class='fab fa-youtube'/></Link>
          </div>
        </div>
      </div>
      <section class='social-media'>
        <div class='social-media-wrap'>
            {/* <div class='footer-logo'>
                <Link to='/' className='social-logo'>
                    Mythri Mandirs <img src='/images/JMSLogo.png' alt='Logo' className='footer-logo-image' />
                </Link>
            </div> */}
            <small class='website-rights'>Jays Woodwork © 2024</small>
        </div>
      </section>
    </div>
  )
}

export default Footer